import { connect } from "react-redux";
import LayoutWithSideMenu from "./LayoutWithSideMenu";

function mapStateToProps(state) {
  return {
    username:
      !!state.authReducer.userInfo && !!state.authReducer.userInfo.name
        ? state.authReducer.userInfo.name
        : "",
    email:
      !!state.authReducer.userInfo && !!state.authReducer.userInfo.email
        ? state.authReducer.userInfo.email
        : "",
    roles:
      !!state.authReducer.userInfo && !!state.authReducer.userInfo.role
        ? state.authReducer.userInfo.role
        : "",
  };
}

const connectedLayoutWithSideMenu = connect(
  mapStateToProps,
  null
)(LayoutWithSideMenu);

export default connectedLayoutWithSideMenu;
